import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { EmotionalIntro } from '../components/EmotionalIntro';
import { WhyReadSection } from '../components/WhyReadSection';
import { BookContents } from '../components/BookContents';
import { DiasporaSection } from '../components/DiasporaSection';
import { WarningSection } from '../components/WarningSection';
import { BookExcerpts } from '../components/BookExcerpts';
import { Testimonials } from '../components/Testimonials';
import { WhyNowSection } from '../components/WhyNowSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { RecentPurchaseNotification } from '../components/RecentPurchaseNotification';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-[#0a0a0a] overflow-x-hidden" data-id="element-332">
      <AnnouncementBar data-id="element-333" />
      <HeroSection data-id="element-334" />
      <div className="mobile-section-divider" aria-hidden="true" data-id="element-335" />
      <EmotionalIntro data-id="element-336" />
      <WhyReadSection data-id="element-337" />
      <div className="mobile-section-divider" aria-hidden="true" data-id="element-338" />
      <BookContents data-id="element-339" />
      <DiasporaSection data-id="element-340" />
      <div className="mobile-section-divider" aria-hidden="true" data-id="element-341" />
      <WarningSection data-id="element-342" />
      <BookExcerpts data-id="element-343" />
      <div className="mobile-section-divider" aria-hidden="true" data-id="element-344" />
      <Testimonials data-id="element-345" />
      <WhyNowSection data-id="element-346" />
      <FAQSection data-id="element-347" />
      <FinalCTA data-id="element-348" />
      <RecentPurchaseNotification data-id="element-349" />
    </main>;
}